import { useAuth } from "contexts/AuthContext";
import { useToast } from "contexts/ToastContext";
import { useState } from "react";
import { createLegalAdvisoryRemark, createLegalRespondbackFeedback, updateLegalAdvisory } from "services/legalAdvisoryService";
import { createLegalResearchRequest } from "services/legalResearchService";
import { createLegislativeDraftingRemark, createLegislativeRespondbackFeedback, getLegislativeDrafting, updateLegislativeDrafting } from "services/legislativeService";
import { LoadingIcon } from "utils/constant";
import { LEGAL_ADVISORY_REQUEST_STATUS } from "utils/constantValues";
import { getUserType } from "utils/helpers";
import { useTranslation } from "react-i18next";

export default function HeadRemark({ setEdit, setFormState, formState, type }: { setEdit: any, setFormState: any, formState: any, type?: string }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const contextData = useAuth();
    
    const handleChange = (
        e: React.ChangeEvent<
            HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        >
    ) => {
        const { name, value } = e.target;
        setFormState((prev: any) => ({
            ...prev,
            [name]: value,
        }));
        console.log("check remark", formState.remark);
    };

    const handleReject = async () => {
        setLoading(true);
        const remarkData = new FormData();
        if (type === "legal")
            remarkData.append("advisory_request", formState.id);
        else
            remarkData.append("instruction", formState.id);
        remarkData.append("role", getUserType(contextData.user?.roles[1]));
        remarkData.append("summary", formState.remark);
        remarkData.append("feedback_type", "Review");
        remarkData.append("given_by", contextData?.user?.full_name || "");

        try {
            let remark_response;
            if (type === "legal")
                remark_response = await createLegalRespondbackFeedback(remarkData);
            else
                remark_response = await createLegislativeRespondbackFeedback(remarkData);
            console.log(remark_response);
            const data = new FormData();
            data.append("status", LEGAL_ADVISORY_REQUEST_STATUS.under_review.value);
            data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.not_forwarded.value);
            let response: any;
            if (type === "legal")
                response = await updateLegalAdvisory(formState.id, data);
            else
                response = await updateLegislativeDrafting(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("FeedbackSubmittedSuccess") || "Feedback submitted successfully!", "success");
            setEdit(false);
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateRequest") || "Failed to update request.", "error");
        } finally {
            setLoading(false);
        }
    }

    const handleForward = async (froward_status: string) => {
        setLoading(true);
        const remarkData = new FormData();
        if (type === "legal")
            remarkData.append("advisory_request", formState.id);
        else
            remarkData.append("instruction", formState.id);
        remarkData.append("role", getUserType(contextData.user?.roles[1]));
        remarkData.append("remark", formState.remark);

        try {
            let remark_response;
            if (type === "legal")
                remark_response = await createLegalAdvisoryRemark(remarkData);
            else
                remark_response = await createLegislativeDraftingRemark(remarkData);
            const data = new FormData();
            data.append("status", LEGAL_ADVISORY_REQUEST_STATUS.head_remark_submitted.value);
            data.append("forward_status", LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_director.value);
            let response: any;
            if (type === "legal")
                response = await updateLegalAdvisory(formState.id, data);
            else
                response = await updateLegislativeDrafting(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("RequestForwardedSuccess") || "Request forwarded successfully!", "success");
            setEdit(false);
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateRequest") || "Failed to update request.", "error");
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <>
            <div className="mt-6">
                <label
                    htmlFor="remark"
                    className="block text-sm font-medium text-gray-500"
                >
                    {t("Remark") || "Remark"}
                </label>
                <textarea
                    id="remark"
                    name="remark"
                    className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-3 focus:ring-blue-500 focus:border-blue-500 sm:text-sm h-24 resize-y"
                    placeholder={t("DetailHere") || "Detail here...."}
                    required
                    value={formState.remark}
                    onChange={handleChange}
                ></textarea>
            </div>
            <div className="mt-4 pb-8 border-b border-gray-200 flex flex-col sm:flex-row justify-between space-y-4 sm:space-y-0 sm:space-x-4">
                <button
                    type="button"
                    className="flex-1 px-6 py-3 rounded-md bg-[#D4D4D4] text-[#212121] font-semibold hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-300 disabled:opacity-50"
                    onClick={handleReject}
                    disabled={loading}
                >
                    {loading ? (
                        <div className="flex items-center justify-center">
                            {LoadingIcon} {t("Submitting") || "Submitting..."}
                        </div>
                    ) : (
                        t("RespondBack") || "Respond back"
                    )}
                </button>
                <div
                    onClick={() => !loading && handleForward(LEGAL_ADVISORY_REQUEST_STATUS.forwarded_to_director.value)}
                    className={`flex-1 text-center cursor-pointer px-6 py-3 rounded-md bg-[#212121] text-white font-semibold hover:bg-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-600 ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                >
                    {loading ? (
                        <div className="flex items-center justify-center">
                            {LoadingIcon} {t("Submitting") || "Submitting..."}
                        </div>
                    ) : (
                        t("ForwardToDirector") || "Forward To Director"
                    )}
                </div>
            </div>
        </>
    );
}